import {
  GreenSystemIcon,
  OrangeSystemIcon,
  StyledSystemIcon,
} from "App/global-style";

import React from "react";
import { AdviceDiffType } from "./utils";

export const Mark = ({
  diffType,
}: {
  diffType: AdviceDiffType;
}): React.ReactElement => {
  switch (diffType) {
    case AdviceDiffType.INFO:
      return <StyledSystemIcon name="information" />;
    case AdviceDiffType.UNAVAILABLE:
      return <StyledSystemIcon name="close" />;
    case AdviceDiffType.CHECKED_DIFF:
    case AdviceDiffType.SLIDER_DIFF:
      return <OrangeSystemIcon name="add" />;
    case AdviceDiffType.NO_DIFF:
    default:
      return <GreenSystemIcon name="check" />;
  }
};

export const getDiffMessageClass = (diffType: AdviceDiffType): string => {
  switch (diffType) {
    case AdviceDiffType.INFO:
      return "AdviceDiffInfo";
    case AdviceDiffType.UNAVAILABLE:
      return "AdviceDiffUnavailable";
    case AdviceDiffType.CHECKED_DIFF:
    case AdviceDiffType.SLIDER_DIFF:
      return "AdviceDiffTrue";
    case AdviceDiffType.NO_DIFF:
    default:
      return "AdviceDiffFalse";
  }
};
